import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.ontology');
import { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import cytoscape from 'cytoscape';


const GRAPH_NODE_PALETTE = [
    { background: '#fee2e2', border: '#dc2626' },
    { background: '#ffedd5', border: '#ea580c' },
    { background: '#fef3c7', border: '#d97706' },
    { background: '#fef9c3', border: '#ca8a04' },
    { background: '#dcfce7', border: '#16a34a' },
    { background: '#d1fae5', border: '#059669' },
    { background: '#ccfbf1', border: '#0f766e' },
    { background: '#cffafe', border: '#0891b2' },
    { background: '#dbeafe', border: '#2563eb' },
    { background: '#e0e7ff', border: '#4f46e5' },
    { background: '#ede9fe', border: '#7c3aed' },
    { background: '#f3e8ff', border: '#9333ea' },
    { background: '#fae8ff', border: '#c026d3' },
    { background: '#fce7f3', border: '#db2777' },
    { background: '#ffe4e6', border: '#e11d48' },
    { background: '#e2e8f0', border: '#475569' }
];


@Component({
    selector: 'wiz-page-ontology',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.ontology/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.ontology-graph {
  min-width: 640px;
  outline: none;
}

.ontology-graph:focus-visible {
  box-shadow: inset 0 0 0 3px rgba(124, 58, 237, 0.35);
}`],
})
export class PageOntologyComponent implements OnInit, AfterViewInit, OnDestroy {
    public loading: boolean = true;
    public actionBusy: boolean = false;
    public previewing: boolean = false;
    public errorMessage: string = '';
    public successMessage: string = '';
    public ontology: any = {};
    public editable: any = {};
    public quality: any = {};
    public versions: any[] = [];
    public selectedOntologyId: string = '';
    public actor: string = '';
    public canWrite: boolean = false;
    public workspaceTab: string = 'graph';

    public draftVersion: string = '';
    public draftSummary: string = '';
    public validationResult: any = null;
    public diffBaseId: string = '';
    public diffTargetId: string = '';
    public diffResult: any = null;

    public graphSearch: string = '';
    public graphZoom: number = 1;
    public graphLayer: string = 'all';
    public graphLayout: string = 'grid';
    public graphIsolatedOnly: boolean = false;
    public selectedGraphEntityNames: string[] = [];
    public selectedGraphItem: any = null;

    public rdfXml: string = '';
    public rdfPreview: any = null;
    public rdfDraftVersion: string = '';
    public rdfChangeSummary: string = '';

    public previewText: string = '1712년 목극등과 박권은 백두산 일대를 조사하였다.';
    public previewResult: any = null;
    public selectedPreviewCandidate: any = null;

    private graphInstance: any = null;
    private viewReady: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const session = this.service.auth.session || {};
        this.actor = String(session?.id || '');
        this.canWrite = ['admin', 'editor'].includes(
            String(session?.role || '').toLowerCase()
        ) && !!this.actor;
        await this.load();
    }

    public ngAfterViewInit() {
        this.viewReady = true;
        this.scheduleGraphInit();
    }

    public ngOnDestroy() {
        if (this.graphInstance) {
            this.graphInstance.destroy();
            this.graphInstance = null;
        }
    }

    private clone(value: any): any {
        return JSON.parse(JSON.stringify(value || {}));
    }

    private setError(message: string) {
        this.errorMessage = message;
        this.successMessage = '';
    }

    private setSuccess(message: string) {
        this.successMessage = message;
        this.errorMessage = '';
    }

    public async load(ontologyId: string = this.selectedOntologyId) {
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call('overview', {
                ontology_id: ontologyId || ''
            });
            if (response.code !== 200) {
                this.setError(response.data?.message || '온톨로지를 불러오지 못했습니다.');
                return;
            }
            this.ontology = response.data?.ontology || {};
            this.quality = response.data?.quality || {};
            this.versions = response.data?.versions || this.ontology?.versions || [];
            this.selectedOntologyId = this.ontology?.id || ontologyId || '';
            this.prepareEditable();
            if (!this.diffBaseId) {
                const active = this.versions.find((item) => item.status === 'active');
                this.diffBaseId = active?.id || this.selectedOntologyId;
            }
            this.diffTargetId = this.selectedOntologyId;
            this.validationResult = this.ontology?.validation || null;
            this.selectedGraphItem = null;
            this.scheduleGraphInit();
        } catch (_error) {
            this.setError('온톨로지를 불러오지 못했습니다.');
        } finally {
            this.loading = false;
            await this.service.render();
            this.scheduleGraphInit();
        }
    }

    private prepareEditable() {
        this.editable = this.clone(this.ontology);
        this.editable.entity_types = this.editable.entity_types || [];
        this.editable.relation_types = this.editable.relation_types || [];
        this.editable.property_definitions = (
            this.editable.property_definitions
            || this.editable.properties
            || []
        );
        this.editable.properties = this.editable.property_definitions;
        const entityNames = new Set(
            this.editable.entity_types.map((item) => String(item?.name || ''))
        );
        this.selectedGraphEntityNames = this.selectedGraphEntityNames.filter(
            (name) => entityNames.has(name)
        );
    }

    public async selectVersion() {
        await this.load(this.selectedOntologyId);
    }

    public async setWorkspaceTab(tab: string) {
        this.workspaceTab = tab;
        await this.service.render();
        if (tab === 'graph') this.scheduleGraphInit();
    }

    public isDraft(): boolean {
        const status = String(this.ontology?.status || '').toLowerCase();
        return status === 'draft' || status === 'validating';
    }

    public isPublished(): boolean {
        return !this.isDraft();
    }

    private requireActor(): boolean {
        if (this.canWrite && this.actor.trim()) return true;
        this.setError('admin 또는 editor 권한의 로그인 세션이 필요합니다.');
        return false;
    }

    public async createDraft() {
        if (!this.requireActor()) return;
        if (!this.draftVersion.trim() || !this.draftSummary.trim()) {
            this.setError('새 버전과 변경 요약을 입력해주세요.');
            await this.service.render();
            return;
        }
        this.actionBusy = true;
        await this.service.render();
        try {
            const response = await wiz.call('create_draft', {
                base_id: this.selectedOntologyId,
                version: this.draftVersion.trim(),
                change_summary: this.draftSummary.trim()
            });
            if (response.code !== 200) {
                this.setError(response.data?.message || '새 초안을 만들지 못했습니다.');
                return;
            }
            const created = response.data?.ontology || response.data || {};
            this.setSuccess('기존 버전을 보존하고 새 초안을 만들었습니다.');
            this.draftVersion = '';
            this.draftSummary = '';
            await this.load(created.id || '');
        } catch (_error) {
            this.setError('새 초안을 만들지 못했습니다.');
        } finally {
            this.actionBusy = false;
            await this.service.render();
        }
    }

    private draftPayload(): any {
        return {
            name: this.editable?.name,
            description: this.editable?.description,
            change_summary: this.editable?.change_summary || this.editable?.change_reason,
            entity_types: this.entities.map((item) => {
                const normalized = this.clone(item);
                const properties = (
                    normalized.properties
                    && !Array.isArray(normalized.properties)
                    && typeof normalized.properties === 'object'
                ) ? normalized.properties : {};
                if (Array.isArray(normalized.property_codes)) {
                    properties.optional = normalized.property_codes;
                }
                normalized.properties = properties;
                delete normalized.property_codes;
                return normalized;
            }),
            property_definitions: this.properties,
            relation_types: this.relations
        };
    }

    public async saveDraft() {
        if (!this.isDraft() || !this.requireActor()) return;
        this.actionBusy = true;
        await this.service.render();
        try {
            const response = await wiz.call('save_draft', {
                ontology_id: this.selectedOntologyId,
                payload: JSON.stringify(this.draftPayload())
            });
            if (response.code !== 200) {
                this.setError(response.data?.message || '초안을 저장하지 못했습니다.');
                return;
            }
            this.setSuccess('초안 변경 내용을 저장했습니다.');
            await this.load(this.selectedOntologyId);
        } catch (_error) {
            this.setError('초안을 저장하지 못했습니다.');
        } finally {
            this.actionBusy = false;
            await this.service.render();
        }
    }

    public async validateDraft() {
        if (!this.requireActor()) return;
        this.actionBusy = true;
        this.validationResult = null;
        await this.service.render();
        try {
            const response = await wiz.call('validate_draft', {
                ontology_id: this.selectedOntologyId,
            });
            if (response.code !== 200) {
                this.setError(response.data?.message || '구조 검증에 실패했습니다.');
                return;
            }
            this.validationResult = response.data;
            this.setSuccess(this.validationHasErrors()
                ? '검증이 끝났습니다. 오류를 수정한 뒤 다시 실행하세요.'
                : '온톨로지 구조 검증을 통과했습니다.');
        } catch (_error) {
            this.setError('구조 검증에 실패했습니다.');
        } finally {
            this.actionBusy = false;
            await this.service.render();
        }
    }

    public async publishDraft() {
        if (!this.isDraft() || !this.requireActor()) return;
        const accepted = await this.service.modal.show({
            title: '온톨로지 새 버전 발행',
            message: '검증된 초안을 active로 발행하고 기존 active 버전은 보존된 retired 상태로 전환합니다.',
            action: '발행',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!accepted) return;
        this.actionBusy = true;
        await this.service.render();
        try {
            const response = await wiz.call('publish_draft', {
                ontology_id: this.selectedOntologyId,
            });
            if (response.code !== 200) {
                this.setError(response.data?.message || '온톨로지를 발행하지 못했습니다.');
                return;
            }
            const published = response.data?.ontology || response.data || {};
            this.setSuccess('새 active 버전을 발행했습니다. 발행본은 읽기 전용입니다.');
            await this.load(published.id || this.selectedOntologyId);
        } catch (_error) {
            this.setError('온톨로지를 발행하지 못했습니다.');
        } finally {
            this.actionBusy = false;
            await this.service.render();
        }
    }

    public async compareVersions() {
        if (!this.diffBaseId || !this.diffTargetId) return;
        this.actionBusy = true;
        this.diffResult = null;
        await this.service.render();
        try {
            const response = await wiz.call('diff', {
                base_id: this.diffBaseId,
                target_id: this.diffTargetId
            });
            if (response.code !== 200) {
                this.setError(response.data?.message || '버전을 비교하지 못했습니다.');
            } else {
                this.diffResult = response.data;
                this.setSuccess('두 버전의 구조 차이를 계산했습니다.');
            }
        } catch (_error) {
            this.setError('버전을 비교하지 못했습니다.');
        } finally {
            this.actionBusy = false;
            await this.service.render();
        }
    }

    public diffSummary(): any {
        return this.diffResult?.diff?.summary || this.diffResult?.summary || {};
    }

    public diffSection(key: string): any {
        return this.diffResult?.diff?.[key] || this.diffResult?.[key] || {
            added: [], changed: [], removed: []
        };
    }

    public diffList(value: any): string {
        if (!Array.isArray(value) || !value.length) return '없음';
        return value.map((item) => typeof item === 'string'
            ? item
            : `${item?.name || item?.code || '항목'}${item?.fields?.length ? ` (${item.fields.join(', ')})` : ''}`
        ).join(', ');
    }

    public get entities(): any[] {
        return this.editable?.entity_types || [];
    }

    public get properties(): any[] {
        return this.editable?.property_definitions || [];
    }

    public get relations(): any[] {
        return this.editable?.relation_types || [];
    }

    public contract(item: any, key: string, fallback: any = null): any {
        if (item?.[key] !== undefined && item?.[key] !== null) return item[key];
        if (item?.properties?.[key] !== undefined && item?.properties?.[key] !== null) {
            return item.properties[key];
        }
        return fallback;
    }

    public list(value: any): string {
        if (Array.isArray(value)) return value.length ? value.join(', ') : '정의 없음';
        if (value === undefined || value === null || value === '') return '정의 없음';
        return String(value);
    }

    public example(item: any): string {
        const value = this.contract(item, 'examples', this.contract(item, 'example', []));
        return Array.isArray(value) ? (value[0] || '예시 준비 중') : String(value || '예시 준비 중');
    }

    public forbidden(item: any): string {
        const value = this.contract(
            item,
            'prohibited_examples',
            this.contract(item, 'forbidden_examples', this.contract(item, 'forbidden_example', []))
        );
        return Array.isArray(value) ? (value[0] || '금지 사례 준비 중') : String(value || '금지 사례 준비 중');
    }

    public csv(value: any): string {
        return Array.isArray(value) ? value.join(', ') : String(value || '');
    }

    public setCsv(item: any, key: string, value: any) {
        item[key] = String(value || '')
            .split(',')
            .map((entry) => entry.trim())
            .filter((entry) => !!entry);
    }

    public entityPropertyCodes(item: any): any[] {
        if (Array.isArray(item?.properties?.optional)) {
            return item.properties.optional;
        }
        if (Array.isArray(item?.property_codes)) return item.property_codes;
        if (Array.isArray(item?.optional_properties)) {
            return item.optional_properties;
        }
        return [];
    }

    public setEntityPropertyCodes(item: any, value: any) {
        const properties = (
            item?.properties
            && !Array.isArray(item.properties)
            && typeof item.properties === 'object'
        ) ? item.properties : {};
        properties.optional = String(value || '')
            .split(',')
            .map((entry) => entry.trim())
            .filter((entry) => !!entry);
        item.properties = properties;
        delete item.property_codes;
    }

    public propertyCardinality(item: any): string {
        if (item?.cardinality) return String(item.cardinality);
        const minimum = Number(item?.minimum_count || 0);
        const maximum = item?.maximum_count;
        return maximum === null || maximum === undefined || maximum === ''
            ? `${minimum}..*`
            : `${minimum}..${maximum}`;
    }

    public relationCardinality(item: any, side: string): string {
        const minimum = item?.[`${side}_minimum_count`]
            ?? item?.[`${side}_min_count`]
            ?? 0;
        const maximum = item?.[`${side}_maximum_count`]
            ?? item?.[`${side}_max_count`];
        return maximum === null || maximum === undefined || maximum === ''
            ? `${minimum}..*`
            : `${minimum}..${maximum}`;
    }

    public addDefinition(kind: string) {
        if (!this.isDraft()) return;
        if (kind === 'entity') {
            this.entities.push({
                name: '', display_name: '', description: '', parent_type: '',
                iri_pattern: 'urn:reviewops:entity:{stable_id}',
                identifier_strategy: [], properties: { required: [], optional: [] }, examples: [],
                icon: 'circle', color: '#7c3aed', status: 'active'
            });
        } else if (kind === 'property') {
            this.properties.push({
                name: '', display_name: '', description: '', value_type: 'string',
                minimum_count: 0, maximum_count: null, is_identifier: false,
                allows_language_tag: false, applies_to: [], status: 'active'
            });
        } else {
            this.relations.push({
                name: '', display_name: '', description: '', subject_types: [],
                object_types: [], subject_minimum_count: 0,
                subject_maximum_count: null, object_minimum_count: 0,
                object_maximum_count: null, inverse_relation_name: '',
                is_symmetric: false, is_transitive: false, examples: [],
                prohibited_examples: [], status: 'active'
            });
        }
    }

    public removeDefinition(kind: string, index: number) {
        if (!this.isDraft()) return;
        const rows = kind === 'entity'
            ? this.entities
            : kind === 'property'
                ? this.properties
                : this.relations;
        rows.splice(index, 1);
    }

    public definitionDomId(kind: string, item: any): string {
        const code = String(item?.name || item?.code || 'new')
            .replace(/[^0-9A-Za-z_-]+/g, '-');
        return `definition-${kind}-${code}`;
    }

    public validationItems(): any[] {
        if (!this.validationResult) return [];
        if (Array.isArray(this.validationResult)) return this.validationResult;
        const explicit = this.validationResult.validation_results
            || this.validationResult.results
            || this.validationResult.items;
        if (Array.isArray(explicit)) return explicit;
        return [
            ...((this.validationResult.errors || []).map((item) => ({ ...item, severity: item.severity || 'error' }))),
            ...((this.validationResult.warnings || []).map((item) => ({ ...item, severity: item.severity || 'warning' })))
        ];
    }

    public validationHasErrors(): boolean {
        if (this.validationResult?.valid === false) return true;
        return this.validationItems().some((item) =>
            String(item?.severity || item?.level || '').toLowerCase() === 'error'
        );
    }

    public validationMessage(item: any): string {
        return item?.message || item?.description || item?.error_message || String(item || '검증 항목');
    }

    public focusValidationItem(item: any) {
        const kindValue = String(item?.target_kind || item?.kind || item?.definition_kind || '').toLowerCase();
        const kind = kindValue.includes('relation')
            ? 'relation'
            : kindValue.includes('property')
                ? 'property'
                : 'entity';
        const target = item?.target_code || item?.target_name || item?.target_id || item?.code || '';
        this.workspaceTab = kind;
        setTimeout(() => {
            document.getElementById(this.definitionDomId(kind, { name: target }))
                ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 0);
    }

    private graphNodeColors(index: number): { background: string; border: string } {
        if (GRAPH_NODE_PALETTE[index]) return GRAPH_NODE_PALETTE[index];
        const hue = Math.round((index * 137.508) % 360);
        return {
            background: `hsl(${hue}, 72%, 88%)`,
            border: `hsl(${hue}, 58%, 42%)`
        };
    }

    public isGraphEntitySelected(item: any): boolean {
        return this.selectedGraphEntityNames.includes(String(item?.name || ''));
    }

    public toggleGraphEntity(item: any) {
        const name = String(item?.name || '');
        if (!name) return;
        const selected = new Set(this.selectedGraphEntityNames);
        selected.has(name) ? selected.delete(name) : selected.add(name);
        this.selectedGraphEntityNames = this.entities
            .map((entity) => String(entity?.name || ''))
            .filter((entityName) => selected.has(entityName));
        this.applyGraphFilters();
        this.selectGraphItem('entity', item);
    }

    public clearGraphEntitySelection() {
        this.selectedGraphEntityNames = [];
        this.selectedGraphItem = null;
        this.applyGraphFilters();
        this.service.render();
    }

    public isIsolatedType(typeName: string): boolean {
        return !this.relations.some((item) =>
            (item?.subject_types || []).includes(typeName)
            || (item?.object_types || []).includes(typeName)
        );
    }

    private scheduleGraphInit() {
        if (!this.viewReady || this.loading || this.workspaceTab !== 'graph') return;
        setTimeout(() => this.initGraph(), 0);
    }

    private initGraph() {
        if (typeof document === 'undefined') return;
        const container = document.getElementById('ontology-schema-graph');
        if (!container) return;
        if (this.graphInstance) this.graphInstance.destroy();

        const nodeIds = new Set(this.entities.map((item) => String(item?.name || '')));
        const nodes = this.entities.map((item, index) => {
            const palette = this.graphNodeColors(index);
            return {
                data: {
                    id: `entity:${item?.name || index}`,
                    label: item?.display_name || item?.name || 'Unnamed',
                    code: item?.name || '',
                    definitionIndex: index,
                    isolated: this.isIsolatedType(item?.name),
                    color: palette.background,
                    borderColor: palette.border
                },
                classes: this.isIsolatedType(item?.name) ? 'isolated' : ''
            };
        });
        const missingEndpoints = new Set<string>();
        const edges = this.relations.flatMap((item, index) => {
            const subjects = (item?.subject_types || []).length
                ? item.subject_types
                : [`__missing_domain__:${index}`];
            const objects = (item?.object_types || []).length
                ? item.object_types
                : [`__missing_range__:${index}`];
            return subjects.flatMap((subject: any, subjectIndex: number) =>
                objects.map((object: any, objectIndex: number) => {
                    const source = String(subject || `__missing_domain__:${index}`);
                    const target = String(object || `__missing_range__:${index}`);
                    const invalid = !nodeIds.has(source) || !nodeIds.has(target);
                    if (!nodeIds.has(source)) missingEndpoints.add(source);
                    if (!nodeIds.has(target)) missingEndpoints.add(target);
                    return {
                    data: {
                        id: `relation:${index}:${item?.name || 'unnamed'}:${subjectIndex}:${objectIndex}`,
                        source: `entity:${source}`,
                        target: `entity:${target}`,
                        label: item?.name || 'RELATION',
                        definitionIndex: index,
                        invalidEndpoint: invalid
                    },
                    classes: invalid ? 'invalid' : ''
                };
                })
            );
        });
        const missingNodes = Array.from(missingEndpoints).map((name) => ({
            data: {
                id: `entity:${name}`,
                label: name.startsWith('__missing_domain__')
                    ? 'domain 누락'
                    : name.startsWith('__missing_range__')
                        ? 'range 누락'
                        : `미정의: ${name}`,
                code: name,
                definitionIndex: -1,
                invalidEndpoint: true,
                color: '#fee2e2',
                borderColor: '#dc2626'
            },
            classes: 'invalid'
        }));

        this.graphInstance = cytoscape({
            container,
            elements: [...nodes, ...missingNodes, ...edges] as any,
            layout: this.graphLayoutOptions(),
            minZoom: 0.4,
            maxZoom: 2.5,
            wheelSensitivity: 0.2,
            userPanningEnabled: true,
            userZoomingEnabled: true,
            boxSelectionEnabled: false,
            autounselectify: true,
            style: [
                {
                    selector: 'node',
                    style: {
                        'background-color': 'data(color)',
                        'border-color': 'data(borderColor)',
                        'border-width': 3,
                        'label': 'data(label)',
                        'color': '#0f172a',
                        'font-size': 11,
                        'font-weight': 700,
                        'text-wrap': 'wrap',
                        'text-max-width': 82,
                        'text-valign': 'center',
                        'text-halign': 'center',
                        'width': 94,
                        'height': 62
                    }
                },
                {
                    selector: 'node.isolated',
                    style: {
                        'border-color': '#dc2626',
                        'border-style': 'dashed'
                    }
                },
                {
                    selector: 'node.invalid',
                    style: {
                        'border-color': '#dc2626',
                        'border-style': 'dashed',
                        'color': '#991b1b'
                    }
                },
                {
                    selector: 'edge',
                    style: {
                        'width': 2,
                        'line-color': '#94a3b8',
                        'target-arrow-color': '#94a3b8',
                        'target-arrow-shape': 'triangle',
                        'curve-style': 'bezier',
                        'label': 'data(label)',
                        'font-size': 8,
                        'color': '#475569',
                        'text-background-color': '#ffffff',
                        'text-background-opacity': 0.88,
                        'text-background-padding': 2,
                        'text-rotation': 'autorotate'
                    }
                },
                {
                    selector: 'node.focus-selected',
                    style: {
                        'border-width': 7,
                        'width': 102,
                        'height': 68,
                        'z-index': 20
                    }
                },
                {
                    selector: 'node.focus-neighbor',
                    style: {
                        'border-width': 4,
                        'z-index': 10
                    }
                },
                {
                    selector: 'edge.focus-edge',
                    style: {
                        'width': 4,
                        'line-color': '#4f46e5',
                        'target-arrow-color': '#4f46e5',
                        'color': '#312e81',
                        'font-size': 9,
                        'text-background-opacity': 1,
                        'z-index': 15
                    }
                },
                {
                    selector: 'edge.invalid',
                    style: {
                        'line-color': '#dc2626',
                        'target-arrow-color': '#dc2626',
                        'line-style': 'dashed'
                    }
                }
            ] as any
        });
        this.graphInstance.on('tap', 'node', (event) => {
            const item = this.entities[Number(event.target.data('definitionIndex'))];
            if (item) {
                this.toggleGraphEntity(item);
            } else if (event.target.data('invalidEndpoint')) {
                this.selectGraphItem('validation', {
                    name: event.target.data('code'),
                    display_name: event.target.data('label'),
                    description: '관계의 domain 또는 range가 정의된 개체 유형과 연결되지 않았습니다.'
                });
            }
        });
        this.graphInstance.on('tap', 'edge', (event) => {
            const item = this.relations[Number(event.target.data('definitionIndex'))];
            if (item) this.selectGraphItem('relation', item);
        });
        this.graphInstance.on('tap', (event) => {
            if (event.target === this.graphInstance) {
                this.clearGraphEntitySelection();
            }
        });
        this.graphInstance.on('zoom', () => {
            this.graphZoom = this.graphInstance.zoom();
            this.service.render();
        });
        this.applyGraphFilters();
        this.graphInstance.fit(undefined, 36);
        this.graphZoom = this.graphInstance.zoom();
    }

    private graphLayoutOptions(): any {
        return this.graphLayout === 'grid'
            ? {
                name: 'grid', animate: false, fit: true, padding: 56,
                avoidOverlap: true, avoidOverlapPadding: 36,
                condense: false, spacingFactor: 1.35
            }
            : {
                name: 'cose', animate: false, fit: true, randomize: true,
                padding: 56, nodeRepulsion: () => 18000,
                nodeOverlap: 40, idealEdgeLength: () => 190,
                edgeElasticity: () => 120, componentSpacing: 140,
                gravity: 0.2, numIter: 1800
            };
    }

    public runGraphLayout() {
        if (!this.graphInstance) return;
        this.graphInstance.layout(this.graphLayoutOptions()).run();
        this.graphInstance.fit(undefined, 36);
    }

    public applyGraphFilters() {
        if (!this.graphInstance) return;
        const query = this.graphSearch.trim().toLowerCase();
        const selectedNodeIds = new Set(
            this.selectedGraphEntityNames.map((name) => `entity:${name}`)
        );
        const hasFocus = selectedNodeIds.size > 0;
        const relatedNodeIds = new Set(selectedNodeIds);

        if (hasFocus) {
            this.graphInstance.edges().forEach((edge) => {
                const source = String(edge.data('source') || '');
                const target = String(edge.data('target') || '');
                if (selectedNodeIds.has(source) || selectedNodeIds.has(target)) {
                    relatedNodeIds.add(source);
                    relatedNodeIds.add(target);
                }
            });
        }

        const nodeMatchesQuery = (node: any): boolean => (
            !query
            || `${node.data('label')} ${node.data('code')}`.toLowerCase().includes(query)
        );

        this.graphInstance.nodes().forEach((node) => {
            const id = String(node.id());
            const selected = selectedNodeIds.has(id);
            const related = relatedNodeIds.has(id);
            const isolatedMatch = !this.graphIsolatedOnly || !!node.data('isolated');
            node.removeClass('focus-selected focus-neighbor focus-dimmed');
            if (selected) node.addClass('focus-selected');
            else if (hasFocus && related) node.addClass('focus-neighbor');
            else if (hasFocus) node.addClass('focus-dimmed');

            const focusOpacity = !hasFocus ? 1 : selected ? 1 : related ? 0.82 : 0.12;
            const opacity = nodeMatchesQuery(node)
                ? focusOpacity
                : Math.min(focusOpacity, 0.14);
            node.style('display', isolatedMatch ? 'element' : 'none');
            node.style('opacity', opacity);
        });

        this.graphInstance.edges().forEach((edge) => {
            const source = String(edge.data('source') || '');
            const target = String(edge.data('target') || '');
            const focused = hasFocus
                && (selectedNodeIds.has(source) || selectedNodeIds.has(target));
            const sourceNode = this.graphInstance.getElementById(source);
            const targetNode = this.graphInstance.getElementById(target);
            const matches = (
                !query
                || String(edge.data('label') || '').toLowerCase().includes(query)
                || nodeMatchesQuery(sourceNode)
                || nodeMatchesQuery(targetNode)
            );
            const visible = this.graphLayer !== 'entity' && !this.graphIsolatedOnly;
            edge.removeClass('focus-edge focus-dimmed');
            if (focused) edge.addClass('focus-edge');
            else if (hasFocus) edge.addClass('focus-dimmed');

            const focusOpacity = focused
                ? 1
                : hasFocus
                    ? 0.06
                    : this.graphLayer === 'relation' ? 1 : 0.72;
            edge.style('display', visible ? 'element' : 'none');
            edge.style('opacity', matches ? focusOpacity : Math.min(focusOpacity, 0.08));
        });
    }

    public zoomGraph(delta: number) {
        if (!this.graphInstance) return;
        const level = Math.max(0.4, Math.min(2.5, this.graphInstance.zoom() + delta));
        this.graphInstance.zoom({
            level,
            renderedPosition: {
                x: this.graphInstance.width() / 2,
                y: this.graphInstance.height() / 2
            }
        });
        this.graphZoom = level;
    }

    public resetGraphView() {
        if (!this.graphInstance) return;
        this.graphInstance.fit(undefined, 36);
        this.graphZoom = this.graphInstance.zoom();
    }

    public selectGraphItem(kind: string, item: any) {
        this.selectedGraphItem = { kind, item };
        this.service.render();
    }

    public graphItemTitle(): string {
        const item = this.selectedGraphItem?.item || {};
        return item.display_name || item.name || '선택 없음';
    }

    public async exportRdf() {
        this.actionBusy = true;
        await this.service.render();
        try {
            const response = await wiz.call('export_rdf', {
                ontology_id: this.selectedOntologyId
            });
            if (response.code !== 200) {
                this.setError(response.data?.message || 'RDF/XML을 내보내지 못했습니다.');
            } else {
                this.rdfXml = String(response.data?.rdf_xml || response.data?.xml || '');
                this.rdfPreview = null;
                this.setSuccess('현재 버전을 RDF/XML 교환 형식으로 내보냈습니다.');
            }
        } catch (_error) {
            this.setError('RDF/XML을 내보내지 못했습니다.');
        } finally {
            this.actionBusy = false;
            await this.service.render();
        }
    }

    public async previewRdf() {
        if (!this.rdfXml.trim()) return;
        this.actionBusy = true;
        this.rdfPreview = null;
        await this.service.render();
        try {
            const response = await wiz.call('preview_rdf', { rdf_xml: this.rdfXml });
            if (response.code !== 200) {
                this.setError(response.data?.message || 'RDF/XML을 검증하지 못했습니다.');
            } else {
                this.rdfPreview = response.data;
                this.setSuccess('가져오기 전 구조와 검증 결과를 확인했습니다.');
            }
        } catch (_error) {
            this.setError('RDF/XML을 검증하지 못했습니다.');
        } finally {
            this.actionBusy = false;
            await this.service.render();
        }
    }

    public async importRdf() {
        if (!this.requireActor()) return;
        if (!this.rdfXml.trim() || !this.rdfDraftVersion.trim() || !this.rdfChangeSummary.trim()) {
            this.setError('RDF/XML, 새 버전, 변경 요약을 모두 입력해주세요.');
            await this.service.render();
            return;
        }
        this.actionBusy = true;
        await this.service.render();
        try {
            const response = await wiz.call('import_rdf', {
                rdf_xml: this.rdfXml,
                base_id: this.selectedOntologyId,
                version: this.rdfDraftVersion.trim(),
                change_summary: this.rdfChangeSummary.trim()
            });
            if (response.code !== 200) {
                this.setError(response.data?.message || 'RDF/XML 초안을 만들지 못했습니다.');
                return;
            }
            const imported = response.data?.ontology || response.data || {};
            this.setSuccess('기존 버전을 덮어쓰지 않고 RDF/XML 기반 새 초안을 만들었습니다.');
            await this.load(imported.id || '');
        } catch (_error) {
            this.setError('RDF/XML 초안을 만들지 못했습니다.');
        } finally {
            this.actionBusy = false;
            await this.service.render();
        }
    }

    public async preview() {
        if (!this.previewText.trim()) return;
        this.previewing = true;
        this.errorMessage = '';
        this.previewResult = null;
        this.selectedPreviewCandidate = null;
        await this.service.render();
        try {
            const response = await wiz.call('preview', { text: this.previewText.trim() });
            if (response.code !== 200) {
                this.setError(response.data?.message || '샌드박스를 실행하지 못했습니다.');
            } else {
                this.previewResult = response.data;
                this.selectedPreviewCandidate = this.previewRows('entity')[0]
                    || this.previewRows('event')[0]
                    || this.previewRows('relation')[0]
                    || null;
            }
        } catch (_error) {
            this.setError('샌드박스를 실행하지 못했습니다.');
        } finally {
            this.previewing = false;
            await this.service.render();
        }
    }

    public previewRows(kind: string): any[] {
        if (!this.previewResult) return [];
        if (kind === 'entity') return this.previewResult.entity_candidates || [];
        if (kind === 'event') return this.previewResult.event_candidates || [];
        return this.previewResult.relation_candidates || [];
    }

    public previewName(item: any): string {
        if (item?.predicate) {
            return `${item?.subject_name || '-'} — ${item.predicate} → ${item?.object_name || '-'}`;
        }
        return item?.candidate_name || item?.event_name || item?.surface_text || item?.id || '-';
    }

    public previewRule(item: any): string {
        return item?.rule_match?.name
            || item?.identity_features?.rule_name
            || item?.attributes?.rule_name
            || item?.qualifiers?.rule_name
            || (item?.identity_features?.ambiguous_short_name
                ? '명칭 경계 규칙 · 의미 검토 필요'
                : '결정적 사전·문형 규칙 일치');
    }

    public previewContract(item: any): string {
        const failures = item?.validation_errors || item?.contract_violations || [];
        return failures.length
            ? `계약 위반 ${failures.length}건`
            : item?.predicate
                ? 'domain·range 계약 통과'
                : '활성 개체 유형 계약 통과';
    }

    public previewOntologyLabel(): string {
        const value = this.previewResult?.ontology || {};
        return `${value.id || this.ontology?.id || '-'} · v${value.version || this.ontology?.version || '-'}`;
    }

    public selectPreview(item: any) {
        this.selectedPreviewCandidate = item;
    }

    private previewBounds(): { start: number; end: number } {
        const text = String(this.previewResult?.full_text || this.previewText || '');
        const start = Math.max(0, Math.min(Number(this.selectedPreviewCandidate?.evidence_start || 0), text.length));
        const end = Math.max(start, Math.min(Number(this.selectedPreviewCandidate?.evidence_end || start), text.length));
        return { start, end };
    }

    public previewBefore(): string {
        return String(this.previewResult?.full_text || this.previewText || '').slice(0, this.previewBounds().start);
    }

    public previewEvidence(): string {
        const bounds = this.previewBounds();
        return String(this.previewResult?.full_text || this.previewText || '').slice(bounds.start, bounds.end);
    }

    public previewAfter(): string {
        return String(this.previewResult?.full_text || this.previewText || '').slice(this.previewBounds().end);
    }

    public eventCenteredRelations(): any[] {
        return this.previewRows('relation').filter((item) =>
            item?.subject_candidate_kind === 'event'
            || item?.object_candidate_kind === 'event'
        );
    }

    public directRelations(): any[] {
        return this.previewRows('relation').filter((item) =>
            item?.subject_candidate_kind !== 'event'
            && item?.object_candidate_kind !== 'event'
        );
    }

    public json(value: any): string {
        return JSON.stringify(value, null, 2);
    }
}

export default PageOntologyComponent;